<template>
  <div>
    <h5>{{ $t("caisse.nouveauTransfert") }}</h5>
    <a-row :gutter="16">
      <a-col :span="13">
        <a-form :form="form">
          <a-form-item
            :label="$t('caisse.typeDeFlux')"
            :labelCol="{ span: 6 }"
            :wrapperCol="{ span: 16 }"
          >
            <a-select
              v-decorator="[
                'fluxType',
                {
                  rules: [
                    {
                      required: true,
                      message: $t('caisse.veillezSelectionnerTypeFluxMessage'),
                    },
                  ],
                },
              ]"
              :placeholder="$t('caisse.veillezSelectionnerTypeFluxMessage')"
              @change="handleFluxTypeChange"
            >
              <a-select-option value="ALIMENTATION_P">{{
                $t("caisse.alimentationCaissePrincipale")
              }}</a-select-option>
              <a-select-option value="ALIMENTATION_SOUS_CAISSES">{{
                $t("caisse.alimentationSousCaisses")
              }}</a-select-option>
              <a-select-option value="VERSEMENT">{{
                $t("caisse.versement")
              }}</a-select-option>
              <a-select-option value="COLLECTE_SOUS_CAISSES">{{
                $t("caisse.collecteSousCaisses")
              }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item
            :label="$t('caisse.libelle')"
            :labelCol="{ span: 6 }"
            :wrapperCol="{ span: 16 }"
          >
            <a-input
              v-decorator="[
                'label',
                {
                  rules: [
                    {
                      required: true,
                      message: $t('caisse.veillezSaisirLibelle'),
                    },
                  ],
                },
              ]"
              :placeholder="$t('caisse.veillezSaisirLibelle')"
            />
          </a-form-item>
          <a-form-item
            :label="$t('caisse.montant')"
            :labelCol="{ span: 6 }"
            :wrapperCol="{ span: 16 }"
          >
            <div style="display: flex; align-items: center">
              <a-input-number
                v-decorator="[
                  'amount',
                  {
                    rules: [
                      {
                        required: true,
                        message: $t('caisse.veillezSaisirMontant'),
                      },
                    ],
                  },
                ]"
                :min="0"
                :step="0.01"
                :precision="3"
                style="width: 100%"
                :placeholder="$t('caisse.veillezSaisirMontant')"
              />
              <a-button
                type="primary"
                class="ml-2"
                :disabled="
                  !form.getFieldValue('caisseSource') ||
                  form.getFieldValue('fluxType') !== 'COLLECTE_SOUS_CAISSES'
                "
                @click="collectAll"
              >
                {{ $t("caisse.toutCollecterBtn") }}
              </a-button>
            </div>
          </a-form-item>
          <a-alert
            v-if="!fluxType"
            type="info"
            show-icon
            class="mb-3"
            :message="$t('caisse.veillezSelectionnerTypeFlux')"
          />
          <div v-show="fluxType">
            <a-form-item
              v-if="fluxType === 'ALIMENTATION_P'"
              :label="$t('caisse.type')"
              :labelCol="{ span: 6 }"
              :wrapperCol="{ span: 16 }"
            >
              <a-select
                v-decorator="[
                  'type',
                  {
                    rules: [
                      {
                        required: true,
                        message: $t('caisse.veillezSelectionnerType'),
                      },
                    ],
                  },
                ]"
                :placeholder="$t('caisse.selectionnerTypeAlimentation')"
                @change="handleTypeChange"
              >
                <a-select-option value="CAISSE_BANQUE">{{
                  $t("caisse.caisseBanque")
                }}</a-select-option>
                <a-select-option value="AUGMENTATION_CAPITAL">{{
                  $t("caisse.augmentationCapital")
                }}</a-select-option>
                <a-select-option value="FONDS">{{
                  $t("caisse.fonds")
                }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item
              v-show="
                selectedType === 'CAISSE_BANQUE' ||
                fluxType !== 'ALIMENTATION_P'
              "
              :label="$t('caisse.caisseSource')"
              :labelCol="{ span: 6 }"
              :wrapperCol="{ span: 16 }"
            >
              <div style="display: flex; align-items: center">
                <a-select
                  v-decorator="[
                    'caisseSource',
                    {
                      rules: [
                        {
                          required: fluxType !== 'ALIMENTATION_P',
                          message: $t('caisse.veillezSelectionnerCaisseSource'),
                        },
                      ],
                    },
                  ]"
                  :placeholder="$t('caisse.selectionnerCaisseSource')"
                  :disabled="
                    fluxType === 'VERSEMENT' ||
                    fluxType === 'ALIMENTATION_SOUS_CAISSES'
                  "
                  @change="fetchStats"
                  style="flex: 1"
                >
                  <a-select-option
                    v-for="compte in fluxType === 'VERSEMENT' ||
                    fluxType === 'ALIMENTATION_SOUS_CAISSES'
                      ? sousCaisse.filter((c) => c._id === caisseId)
                      : fluxType === 'COLLECTE_SOUS_CAISSES'
                      ? sousCaisse
                      : caisseBanque"
                    :key="compte._id"
                    :value="compte._id"
                    :disabled="
                      compte.type === 'PRINCIPAL' ||
                      (fluxType === 'COLLECTE_SOUS_CAISSES' &&
                        compte.availability === 'OPEN')
                    "
                  >
                    {{ compte.name }} ({{ compte.reference }})
                  </a-select-option>
                </a-select>
                <a-button
                  type="default"
                  icon="table"
                  :disabled="relatedCaisse === null"
                  class="ml-2"
                  @click="showTransactionsModal"
                  style="margin-left: 8px"
                >
                  {{ $t("caisse.paymentsEffectues") }}
                </a-button>
              </div>
            </a-form-item>
            <a-form-item
              :label="$t('caisse.caisseDestination')"
              :labelCol="{ span: 6 }"
              :wrapperCol="{ span: 16 }"
              :disabled="fluxType === 'COLLECTE_SOUS_CAISSES'"
            >
              <a-select
                v-decorator="[
                  'caisseDestination',
                  {
                    rules: [
                      {
                        required: true,
                        message: $t(
                          'caisse.veillezSelectionnerCaisseDestination'
                        ),
                      },
                    ],
                  },
                ]"
                :placeholder="$t('caisse.selectionnerCaisseDestination')"
                :disabled="
                  fluxType === 'COLLECTE_SOUS_CAISSES' ||
                  fluxType === 'ALIMENTATION_P'
                "
                @change="fetchStats"
              >
                <a-select-option
                  v-for="compte in fluxType === 'VERSEMENT'
                    ? caisseBanque
                    : sousCaisse"
                  :key="compte._id"
                  :value="compte._id"
                  :disabled="compte.type === 'PRINCIPAL'"
                >
                  {{ compte.name }} ({{ compte.reference }})
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item
              :label="$t('caisse.commentaire')"
              :labelCol="{ span: 6 }"
              :wrapperCol="{ span: 16 }"
            >
              <a-textarea
                v-decorator="[
                  'comment',
                  {
                    rules: [
                      {
                        max: 500,
                        message: $t('caisse.commentaireMaxCaracteres'),
                      },
                    ],
                  },
                ]"
                :rows="4"
                :placeholder="$t('caisse.ajouterCommentaire')"
              />
            </a-form-item>
          </div>
          <div class="text-right mt-3">
            <a-button type="primary" :loading="loading" @click="handleSubmit">
              {{ $t("caisse.valider") }}
            </a-button>
          </div>
        </a-form>
      </a-col>
      <a-col :span="11">
        <CaisseDetails
          :stats="stats"
          :loading="loadingStats"
          :showName="true"
          :showTPE="false"
          :showAuthorizedUsers="true"
        />
      </a-col>
    </a-row>

    <!-- Transactions Modal -->
    <a-modal
      v-model="transactionsModalVisible"
      :title="$t('caisse.transactionsDeLaCaisse')"
      width="90%"
      :footer="null"
      :destroyOnClose="true"
    >
      <CaisseInvoicesTable :caisseId="relatedCaisse" />
    </a-modal>

    <a-modal
      :visible="partialCollectionError !== null"
      :title="$t('caisse.reglesCollectePartielle')"
      :closable="true"
      :maskClosable="true"
      :destroyOnClose="true"
      width="640px"
      class="collection-rules-modal"
      @cancel="partialCollectionError = null"
    >
      <div v-if="partialCollectionError" class="collection-rules">
        <div class="collection-amounts">
          <div class="amount-card amount-requested">
            <a-icon type="arrow-up" />
            <div>
              <small>{{ $t("caisse.montantDemande") }}</small>
              <strong>{{ partialCollectionError.requestedAmount }}</strong>
            </div>
          </div>
          <a-icon type="right" class="amount-arrow" />
          <div class="amount-card amount-available">
            <a-icon type="wallet" />
            <div>
              <small>{{ $t("caisse.especesDisponibles") }}</small>
              <strong>{{ partialCollectionError.availableCash }}</strong>
            </div>
          </div>
        </div>

        <a-alert
          type="warning"
          show-icon
          :message="$t('caisse.collectePartielleEspecesUniquement')"
          class="collection-warning"
        />

        <div class="collection-rule">
          <a-icon type="check-circle" class="rule-icon rule-success" />
          <span>{{ $t("caisse.collecteTotaleTousModes") }}</span>
        </div>
        <div class="collection-rule">
          <a-icon type="stop" class="rule-icon rule-danger" />
          <span>{{ $t("caisse.modesNonEspecesCollecteTotale") }}</span>
        </div>

        <h5 class="steps-title">{{ $t("caisse.pourMontantPrecis") }}</h5>
        <div class="collection-step">
          <span class="step-number">1</span>
          <span>{{ $t("caisse.etapeCollecterTout") }}</span>
        </div>
        <div class="collection-step">
          <span class="step-number">2</span>
          <span>{{ $t("caisse.etapeTransfererMontant") }}</span>
        </div>
      </div>

      <template slot="footer">
        <a-button type="primary" @click="partialCollectionError = null">
          {{ $t("action.fermer") }}
        </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import apiClient from "@/services/axios";
import CaisseDetails from "./CaisseDetails.vue";
import CaisseInvoicesTable from "./CaisseInvoicesTable.vue";

export default {
  name: "CaisseAlimentationTab",
  components: {
    CaisseDetails,
    CaisseInvoicesTable,
  },
  props: {
    caisseId: {
      type: String,
      required: true,
    },
    caisseType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      selectedType: null,
      fluxType: null,
      caisseBanque: [],
      sousCaisse: [],
      loadingStats: false,
      stats: null,
      relatedCaisse: null,
      transactionsModalVisible: false,
      partialCollectionError: null,
      form: this.$form.createForm(this),
    };
  },
  created() {
    this.fetchCaisses();
  },
  methods: {
    handleTypeChange(value) {
      this.selectedType = value;
      this.form.setFieldsValue({ caisseSource: undefined });
    },
    handleFluxTypeChange(value) {
      this.fluxType = value;
      if (value === "VERSEMENT") {
        this.form.setFieldsValue({
          caisseSource: this.caisseId,
          caisseDestination: undefined,
        });
      } else if (value === "COLLECTE_SOUS_CAISSES") {
        this.form.setFieldsValue({
          caisseSource: undefined,
          caisseDestination: this.caisseId,
        });
      } else if (value === "ALIMENTATION_P") {
        this.form.setFieldsValue({
          caisseSource: undefined,
          caisseDestination: this.caisseId,
        });
      } else if (value === "ALIMENTATION_SOUS_CAISSES") {
        this.form.setFieldsValue({
          caisseSource: this.caisseId,
          caisseDestination: undefined,
        });
      }
    },
    async fetchCaisses() {
      try {
        const res = await apiClient.get("/compV3/caisse");
        this.caisseBanque = res.data.filter((caisse) => caisse.type === "BANK");
        this.sousCaisse = res.data.filter((caisse) => caisse.type !== "BANK");
      } catch (error) {
        this.$message.error(this.$t("caisse.erreurChargementCaisses"));
      }
    },
    async fetchStats(id) {
      if (id && id !== this.caisseId) {
        this.relatedCaisse = id;
        try {
          this.loadingStats = true;
          this.stats = null;
          const res = await apiClient.get(`/compV3/caisse/stats/${id}`);
          this.stats = res.data;
        } catch (error) {
          console.error(error);
          this.$message.error(this.$t("caisse.erreurChargementStatistiques"));
        } finally {
          this.loadingStats = false;
        }
      }
    },
    async handleSubmit() {
      this.loading = true;
      try {
        const values = await this.form.validateFields();
        await apiClient.put(`/compV3/caisse-transfer`, values);
        this.$message.success(this.$t("caisse.alimentationEffectueeSucces"));
        this.form.resetFields();
        this.selectedType = null;
        this.fluxType = null;
        this.fetchStats(this.relatedCaisse);
        this.$emit("success");
      } catch (error) {
        // Try to get the response body if available
        let errorMsg = this.$t("caisse.erreurAlimentation");
        if (error.response && error.response.data && error.response.data.code) {
          // Try to extract a message from the API response
          const { code, requestedAmount, availableCash } = error.response.data;
          if (code === "PARTIAL_COLLECTION_CASH_ONLY") {
            this.partialCollectionError = {
              requestedAmount,
              availableCash,
            };
            return;
          }
          errorMsg = this.$t("errorCode." + code);
        }
        this.$message.error(errorMsg);
      } finally {
        this.loading = false;
      }
    },
    async collectAll() {
      const sourceId = this.form.getFieldValue("caisseSource");
      if (!sourceId) return;

      try {
        if (this.stats.balance) {
          this.form.setFieldsValue({ amount: this.stats.balance });
        }
      } catch (error) {
        this.$message.error(this.$t("caisse.erreurRecuperationSolde"));
      }
    },
    showTransactionsModal() {
      this.transactionsModalVisible = true;
    },
  },
};
</script>

<style scoped>
.collection-rules {
  color: #263238;
}

.collection-amounts {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 20px;
}

.amount-card {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  padding: 14px 16px;
  border: 1px solid;
  border-radius: 8px;
}

.amount-card > .anticon {
  font-size: 22px;
}

.amount-card small,
.amount-card strong {
  display: block;
}

.amount-card strong {
  margin-top: 2px;
  font-size: 20px;
}

.amount-requested {
  color: #cf1322;
  background: #fff1f0;
  border-color: #ffa39e;
}

.amount-available {
  color: #237804;
  background: #f6ffed;
  border-color: #b7eb8f;
}

.amount-arrow {
  color: #8c8c8c;
}

.collection-warning {
  margin-bottom: 18px;
}

.collection-rule {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 12px 0;
  line-height: 1.5;
}

.rule-icon {
  margin-top: 4px;
  font-size: 16px;
}

.rule-success {
  color: #52c41a;
}

.rule-danger {
  color: #f5222d;
}

.steps-title {
  margin: 20px 0 10px;
  font-weight: 600;
}

.collection-step {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  margin-top: 8px;
  background: #f5f7fa;
  border-radius: 6px;
}

.step-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  color: #fff;
  font-weight: 600;
  background: #1890ff;
  border-radius: 50%;
}

@media (max-width: 576px) {
  .collection-amounts {
    flex-direction: column;
  }

  .amount-card {
    width: 100%;
  }

  .amount-arrow {
    transform: rotate(90deg);
  }
}
</style>
